// extracted by mini-css-extract-plugin
export var contained = "FullWidthContentTiles-module--contained--5bf9a";
export var fullwidthcontenttiles = "FullWidthContentTiles-module--fullwidthcontenttiles--ef880";